/* RugLab — lab sinematik gorunumu icin sayfa konumu.
 *
 * SORUN (Doruk, 2026-07-29, masaustu): sayfa asagi kaydirilmisken bir lab'e
 * girilince sahne tam ekrani kaplamiyor; ustte kesik kaliyor, altinda guven
 * seridi ve footer goruluyor. Kullanici "yukari asagi yapamiyorum, boyle kaldi"
 * diye tarif etti — aslinda kaydirilabiliyor ama gorunum yanlis cerceveleniyor.
 * Sebep: .rl-studio tam olarak 100svh yuksekliginde ve overflow:hidden; lab'e
 * girerken sayfa basa alinmiyor.
 *
 * NEDEN AYRI DOSYA: ruglab-studio.js cekismeli (Codex de ayni dosyada calisiyor).
 * Bu davranis o dosyaya hic dokunmadan, sinif degisimini gozlemleyerek ekleniyor.
 */
(function () {
  "use strict";
  var kok = document.querySelector(".rl-studio");
  if (!kok || !window.MutationObserver) return;

  var kilitli = false;
  var zaman = null;

  function kilitle(ac) {
    if (ac === kilitli) return;
    kilitli = ac;
    document.documentElement.classList.toggle("rl-lab-open", ac);
  }

  function uygula() {
    var odakta = kok.classList.contains("is-focused");
    if (zaman) { window.clearTimeout(zaman); zaman = null; }
    if (!odakta) { kilitle(false); return; }

    /* Sahneyi cerceveye otur: basa al. Zaten tepedeysek beklemeden kilitle,
       degilsek yumusak kaydirma bitene kadar bekle (kilit kaydirmayi keserdi). */
    if (window.scrollY > 2) {
      try { window.scrollTo({ top: 0, behavior: "smooth" }); }
      catch (e) { window.scrollTo(0, 0); }
      zaman = window.setTimeout(function () { kilitle(true); }, 480);
    } else {
      kilitle(true);
    }
  }

  new MutationObserver(uygula).observe(kok, { attributes: true, attributeFilter: ["class"] });
  uygula();
})();
